<template>
	<div class="dc-post-grid-pagination">
		<nav v-if="totalPages > 1 && postNavigationType === 'pager'" class="dc-post-grid-pager-dots">
			<a 
				v-for="number in totalPages"
				:class="['dc-post-grid-pager-dot', {
					'active' : number===currentPaged
				}]" 
				@click.stop.prevent="goToPage(number)">
				<span class="screen-reader-text">{{ number }}</span>
			</a>
		</nav>
		<span class="dc-post-grid-current-page">{{ currentPaged }} / {{ totalPages }}</span>
		<button 
	        :class="['dc-post-grid-previous', buttonClassString, {
	        	disabled: (currentPaged<=1)
	        }]"
	        :aria-disabled="currentPaged<=1"
			@click.stop.prevent="changePage('previous')">
				<span class="dc-button-text">{{ dctxt('previous') }}</span>
		</button>
		<button 
	        :class="['dc-post-grid-next', buttonClassString, {
	        	disabled: (currentPaged>=totalPages)
	        }]"
	        :aria-disabled="currentPaged>=totalPages"
			@click.stop.prevent="changePage('next')">
				<span class="dc-button-text">{{ dctxt('next') }}</span>
		</button>
	</div>
</template>

<script>
import { Translatable } from '@dc-post-grid/mixins/Translatable';
export default {
	mixins: [
		Translatable
	],
	props: {
		currentPaged: {
			type: Number,
			required: true
		},
		totalPages: {
			type: Number,
			required: true
		},
		postNavigationType: {
			type: String
		},
		buttonClass: {
			type: String
		}
	},
	computed: {
		buttonClassString() {
			if (typeof this.buttonClass !== 'undefined') return this.buttonClass;
			return 'dc-button';
		}
	},
	methods: {
		changePage(direction) {
			const tmpCurrentPaged = parseInt(this.currentPaged);
			const newCurrentPage = (direction==='previous') ? tmpCurrentPaged - 1 : tmpCurrentPaged + 1;
			if ( newCurrentPage < 1 || newCurrentPage > this.totalPages ) return;
            this.$emit('update-current-paged', newCurrentPage)
		},
		goToPage(number) {
            this.$emit('update-current-paged', number)
		}
	},
}
</script>
